import React from "react";
import styled from "styled-components";

export default function CustomCell(props) {
  return <Cell {...props}>{props.children}</Cell>;
}

const Cell = styled.div.attrs((p) => ({
  "data-variant": p.variant,
}))`
  background: ${(p) =>
    p.variant === "header" ? "var(--surface-100)" : "white"};
  font-weight: ${(p) => (p.variant === "header" ? "bold" : "normal")};
  align-items: ${({ align }) => align || "center"};
  justify-content: ${({ justify }) => justify || "center"};
  display: flex;
  width: ${(p) => (p.width ? p.width : "100%")};
  padding: 8px 4px;
  text-align: ${({ textAlign }) => textAlign || "center"};
  box-sizing: border-box;
  position: relative;
  
  /* Right border for all cells except last */
  &:not(:last-child) {
    border-right: 1px solid var(--surface-300);
  }
  
  /* Left border when specified */
  ${(p) => p.leftBorder && `
    border-left: 1px solid var(--surface-300);
  `}
  
  /* Right border when specifically needed on last cell */
  ${(p) => p.rightBorder && `
    border-right: 1px solid var(--surface-300);
  `}
  
  /* Last cell styling */
  &:last-child {
    border-bottom-right-radius: 8px;
  }
  
  /* Full border override when needed */
  ${(p) => p.fullBorder && `
    border: 1px solid var(--surface-300);
  `}
`;
